var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 98 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .aMasterCard{fill:#fff;}.bMasterCard{fill:#ff9800;}.cMasterCard{fill:#d50000;}.dMasterCard{fill:#ff3d00;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aMasterCard",
    width: 98,
    height: 62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bMasterCard",
    d: "M32,10A14,14,0,1,0,46,24,14,14,0,0,0,32,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cMasterCard",
    d: "M16,10A14,14,0,1,0,30,24,14,14,0,0,0,16,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dMasterCard",
    d: "M18,24a13.976,13.976,0,0,0,6,11.48,13.983,13.983,0,0,0,0-22.96A13.976,13.976,0,0,0,18,24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.911e517d3fa6ba0c03297ecf537d759a.svg";
export { ForwardRef as ReactComponent };